import store from "@/store";
import { Permission } from "@/utils/permissions";
import { NavigationGuardNext, Route, RouteRecord } from "vue-router";
import { permissionMixin } from "@/utils/mixins";

export const authorizationGuard = (
  to: Route,
  _from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // if any of the routes in ./router has a meta named 'requiresAuth: true'
  // then check if the user is logged in before routing to this path:
  if (to.matched.some((record: RouteRecord) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({ name: "auth" });
    } else {
      next();
    }
  }
  // else if any of the routes in ./router.js has a meta named 'requiresLogged: true'
  // then check if the user is logged in; if true continue to home page else continue routing to the destination path
  // this comes to play if the user is logged in and tries to access the login/register page
  else if (
    to.matched.some((record: RouteRecord) => record.meta.requiresLogged)
  ) {
    if (store.getters.loggedIn) {
      next({ name: "clients" });
    } else {
      next();
    }
  } else {
    next();
  }
};

export const permissionsGuard = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) => {
  const perms = to.meta.permissionsRequired as Permission[] | undefined;
  if (!perms || perms.length === 0) {
    next();
  } else if (permissionMixin.methods.hasPermissions(perms)) {
    next();
  } else {
    if (from.name) {
      return;
    } else {
      next({ name: "clients" });
    }
  }
};
